module.exports = __webpack_public_path__ + "static/img/bb_01.e4f6aee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bb_01.png
// module id = gad1
// module chunks = 1